export const FeaturesKeys = {
    paging: "getFeaturesPaging",
    delete: "deleteFeature",
    get: "getFeatureById",
    create: "createFeature",
    update: "updateFeature",
    getRole: "getFeatureRoleMapping",
    addRole: "addFeatureRoleMapping",
    deleteRole: "deleteFeatureRoleMapping",
    getFeatureAccess: "getFeatureAccessMapping",
    addFeatureAccess: "addFeatureAccessMapping",
    deleteFeatureAccess: "deleteFeatureAccessMapping",
    notInRole: "featureNotInRole",
    notInFeatureAccess: "featureNotInFeatureAccess",
    tree: "featureTreeView"
}